import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './css/getStarted.module.css'

export const GetStarted = () => {

       const [md, setMd] = useState(false)

       window.addEventListener("resize", ()=>{window.innerWidth > 765 ? setMd(true) : setMd(false) })

    return(
        <div className={`${styles.sans} ${styles.box} ${styles.flex} ${styles.py24} ${styles.py4} ${styles.textcenter}`}>
            <h1 className={`${styles.fontbold} ${styles.box}  ${styles.text3xl} ${styles.leadingsnug} ${styles.tighter}`}>
                Everything you need to start blogging as a developer!
            </h1>
            <h3 className={`${styles.mb10} ${styles.leadingsnug} ${styles.textbrandgrey600} ${styles.tight}`}>
            Own your content, share ideas, and
            <br />
            connect with the global dev community!
            </h3>
            <NavLink className={`${styles.textnone} ${styles.btn_hn_primary}`} to="/">
               {md ? "Start your personal blog for FREE":"Get started"}
            </NavLink>
        </div>
    )
}